import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Thank you for your inquiry. The PuttLab team will be in touch shortly.');
  };
  return <div className="w-full pt-24 bg-brand-cream-light min-h-screen" data-id="element-406">
      <div className="max-w-7xl mx-auto px-6 py-24" data-id="element-407">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-408">
          {/* Info Side */}
          <div className="lg:col-span-5" data-id="element-409">
            <ScrollReveal data-id="element-410">
              <SectionHeading eyebrow="Start a Project" title="Let's create something unforgettable." subtitle="Tell us about your space, your vision, and what kind of experience you want to build." data-id="element-411" />

              <div className="mt-16 space-y-8 font-body" data-id="element-412">
                <div data-id="element-413">
                  <h4 className="text-brand-gold font-bold uppercase tracking-widest text-xs mb-2" data-id="element-414">
                    Email
                  </h4>
                  <a href="mailto:hello@puttlabstudio.com" className="text-xl text-brand-green-deep hover:text-brand-gold transition-colors" data-id="element-415">
                    hello@puttlabstudio.com
                  </a>
                </div>
                <div data-id="element-416">
                  <h4 className="text-brand-gold font-bold uppercase tracking-widest text-xs mb-2" data-id="element-417">
                    Location
                  </h4>
                  <p className="text-xl text-brand-green-deep" data-id="element-418">
                    Toronto
                    <br data-id="element-419" />
                    <span className="text-brand-stone text-base" data-id="element-420">
                      Available for global projects
                    </span>
                  </p>
                </div>
              </div>
            </ScrollReveal>
          </div>

          {/* Form Side */}
          <div className="lg:col-span-7" data-id="element-421">
            <ScrollReveal delay={0.2} data-id="element-422">
              <form onSubmit={handleSubmit} className="bg-white p-8 md:p-12 rounded-sm shadow-xl border border-brand-stone/10" data-id="element-423">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-424">
                  <div data-id="element-425">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-426">
                      Name
                    </label>
                    <input type="text" required className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-427" />
                  </div>
                  <div data-id="element-428">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-429">
                      Company (Optional)
                    </label>
                    <input type="text" className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-430" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-431">
                  <div data-id="element-432">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-433">
                      Email
                    </label>
                    <input type="email" required className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-434" />
                  </div>
                  <div data-id="element-435">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-436">
                      Phone
                    </label>
                    <input type="tel" className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-437" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-438">
                  <div data-id="element-439">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-440">
                      Property Type
                    </label>
                    <select className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body appearance-none" data-id="element-441">
                      <option data-id="element-442">Residential</option>
                      <option data-id="element-443">Resort / Hotel</option>
                      <option data-id="element-444">Commercial Development</option>
                      <option data-id="element-445">Event / Activation</option>
                      <option data-id="element-446">Other</option>
                    </select>
                  </div>
                  <div data-id="element-447">
                    <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-448">
                      Budget Range
                    </label>
                    <select className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body appearance-none" data-id="element-449">
                      <option data-id="element-450">$10k - $25k</option>
                      <option data-id="element-451">$25k - $50k</option>
                      <option data-id="element-452">$50k - $100k</option>
                      <option data-id="element-453">$100k+</option>
                    </select>
                  </div>
                </div>

                <div className="mb-6" data-id="element-454">
                  <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-455">
                    Location (City, State/Prov)
                  </label>
                  <input type="text" required className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body" data-id="element-456" />
                </div>

                <div className="mb-8" data-id="element-457">
                  <label className="block font-body text-sm font-medium text-brand-charcoal mb-2" data-id="element-458">
                    Notes / Vision
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 bg-brand-cream-light border border-brand-stone/30 rounded-sm focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors font-body resize-none" placeholder="Tell us about the space and what you're hoping to achieve..." data-id="element-459"></textarea>
                </div>

                <Button type="submit" variant="dark" className="w-full" data-id="element-460">
                  Submit Inquiry
                </Button>
              </form>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </div>;
}